
import {Component, Vue, Watch} from 'vue-property-decorator'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import UserEditor from '@/views/module-user-manage/user-editor.vue'
import UserChargeEditor from '@/views/module-user-manage/user-charge-editor.vue'
import CourierInfo from '@/model/modules/CourierInfo'
import CourierService from '@/service/modules/CourierService'
import CourierEditor from '@/views/module-courier-manage/courier-editor.vue'
import PostcodeDataEditor from '@/views/module-courier-manage/postcode-data-editor.vue'
import StealFreightDataEditor from '@/views/module-courier-manage/steal-freight-data-editor.vue'

@Component({
  components: {StealFreightDataEditor, PostcodeDataEditor, CourierEditor, UserChargeEditor, UserEditor}
})
export default class ModuleCourierManage extends Vue {
  listLoadingState: boolean = false
  headerDefine: any = [
    {text: '物流方式ID', value: 'id'},
    {text: '物流方式关键字', value: 'onlyKey'},
    {text: '物流方式名称', value: 'courierName'},
    {text: '操作', value: 'action', sortable: false}
  ]

  queryLikeResult: BasePageableInfo<CourierInfo> = new BasePageableInfo<CourierInfo>()
  queryType: string = 'courierName'
  queryWord: string = ''
  pageNum: number = 1
  pageSize: number = 20
  pageSizeOptions = [{text: '20条/页', value: 20}, {text: '50条/页', value: 50}, {
    text: '200条/页',
    value: 200
  }, {text: '1000条/页', value: 1000}, {text: '2000条/页', value: 2000}]

  mounted() {
    this.refreshAllData()
  }

  @Watch('pageNum')
  onPageNumChanged() {
    this.refreshAllData()
  }

  @Watch('pageSize')
  onPageSizeChanged() {
    this.refreshAllData()
  }

  refreshAllData() {
    this.listLoadingState = true
    const searchExample = {}
    searchExample[this.queryType] = this.queryWord
    CourierService.list(searchExample, this.pageNum - 1, this.pageSize)
      .then((result: BasePageableInfo<CourierInfo>) => {
        this.queryLikeResult = result
        this.listLoadingState = false
      })
  }

  newItem() {
    this.editItem(new CourierInfo())
  }

  editItem(item: CourierInfo) {
    const self = this
    // @ts-ignore
    this.$refs.courierEditor.showEditor(item, function () {
      self.refreshAllData()
    })
  }

  editPostcode(item: CourierInfo) {
    const self = this
    // @ts-ignore
    this.$refs.postcodeDataEditor.showEditor(item, function () {
      self.refreshAllData()
    })
  }

  editStealFreight(item: CourierInfo) {
    const self = this
    // @ts-ignore
    this.$refs.stealFreightDataEditor.showEditor(item, function () {
      self.refreshAllData()
    })
  }
}
